module.exports = __webpack_public_path__ + "img/_20230208111655.2c16a4f5.png";